module.exports = __webpack_public_path__ + "img/w_o.9440d246.png";